import {useHistory, useParams} from "react-router-dom";
import React, {useContext, useRef, useState, useEffect, Fragment} from "react";
import {TranslateContext} from "../../context/TranslateContext";
import {
    getUtenteFromToken,
    PASSWORD_LENGTH,
    PASSWORD_LETTERS_DIGITS, PASSWORD_NO_FORBIDDEN_CHARS,
    PASSWORD_SPECIAL_CHARS
} from "../../utility/common";
import {resetPasswordApi} from "./services/ResetPasswordServices";
import ResetPasswordView from "./ResetPasswordView";
import {Divider} from "primereact/divider";
import FooterPassword from "./components/FooterPassword";

export default function ResetPasswordController() {
    const {token} = useParams()

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [passwordSel, setPasswordSel] = useState("");
    const [passwordCriteri, setPasswordCriteri] = useState({});
    const [passwordOk, setPasswordOk] = useState(false);
    const [password2Sel, setPassword2Sel] = useState("");
    const [password2Criteri, setPassword2Criteri] = useState({});
    const [password2Ok, setPassword2Ok] = useState(false);

    const history = useHistory();
    const formikRef = useRef();
    const {translate} = useContext(TranslateContext);

    function getCriteriPassword(password) {
        let lengthOk = password?.length >= 8;
        let lettersDigitsOk = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/.test(password);
        let specialCharsOk = /[!#$%&'()*+,-.:;<=>@]/.test(password);
        let noForbinnedCharsOK = !password || /^[!-~]+$/.test(password);

        let ret = {};
        ret[PASSWORD_LENGTH] = lengthOk;
        ret[PASSWORD_LETTERS_DIGITS] = lettersDigitsOk;
        ret[PASSWORD_SPECIAL_CHARS] = specialCharsOk;
        ret[PASSWORD_NO_FORBIDDEN_CHARS] = noForbinnedCharsOK;
        return ret;
    }

    useEffect(() => {
        let criteri = getCriteriPassword(passwordSel);
        setPasswordCriteri(criteri);

        // la password è ok se tutti i criteri sono rispettati
        setPasswordOk(Object.values(criteri).every(b => b));
    }, [passwordSel])

    useEffect(() => {
        let criteri = getCriteriPassword(password2Sel);
        setPassword2Criteri(criteri);

        // la password è ok se tutti i criteri sono rispettati
        setPassword2Ok(Object.values(criteri).every(b => b));
    }, [password2Sel])

    function onCloseModal() {
        setShow(false);
        history.push("/");
    }

    const initialValuesForm = {
        password: '',
        password2: ''
    }

    async function onSubmitForm(values) {
        if (values.password === values.password2) {
            let utente = getUtenteFromToken(token);
            if (utente && utente.id_utente && utente.id_utente !== '') {
                const usr = {
                    id_utente: utente.id_utente,
                    password: values.password,
                    password2: values.password2,
                };

                const response = await resetPasswordApi(usr, token);
                setModalMsg(response.data.description);
                setShow(true);
            }
        } else {
            setModalMsg(translate('La Password e la Conferma password devono avere lo stesso valore'));
            setShow(true);
        }
    }

    function getFooterPassword(criteriPassword) {
        return (
            <FooterPassword
            lengthOk={criteriPassword[PASSWORD_LENGTH]}
            lettersDigitsOk={criteriPassword[PASSWORD_LETTERS_DIGITS]}
            noForbinnedCharsOK={criteriPassword[PASSWORD_NO_FORBIDDEN_CHARS]}
            specialCharsOk={criteriPassword[PASSWORD_SPECIAL_CHARS]}
            />
        )
    }

    function getPasswordFooter() {
        return (
            <Fragment>
                <Divider/>
                {getFooterPassword(passwordCriteri)}
            </Fragment>
        );
    }

    function getConfirmPasswordFooter() {
        return (
            <Fragment>
                <Divider/>
                {getFooterPassword(password2Criteri)}
            </Fragment>
        );
    }

    function onChangePassword(event) {
        setPasswordSel(event.target.value);
    }

    function onChangeConfirmPassword(event) {
        setPassword2Sel(event.target.value);
    }

    return (
        <ResetPasswordView
            show={show}
            modalMsg={modalMsg}
            onCloseModal={onCloseModal}
            onSubmitForm={onSubmitForm}
            initialValuesForm={initialValuesForm}
            formikRef={formikRef}
            getPasswordFooter={getPasswordFooter}
            getConfirmPasswordFooter={getConfirmPasswordFooter}
            passwordOk={passwordOk}
            password2Ok={password2Ok}
            onChangePassword={onChangePassword}
            onChangeConfirmPassword={onChangeConfirmPassword}
        />
    )
}